<template>
  <!-- header-area-start -->
  <header class="header-area p-relative">
    <div id="header-sticky" class="tp-header-2">
      <div class="container custom-container">
        <div class="row align-items-center">
          <div class="col-xl-3 col-lg-4 col-md-6 col-6">
            <div class="tp-header-2-right d-flex align-items-center">
              <div class="tp-header-inner-logo tp-header-logo">
                <router-link :to="{ name: 'home' }">
                  <img :src="(lms_website.settings_list?.logo)?lms_website.settings_list?.logo:'/assets/lms_website/images/unix_logo-sm.jpg'" alt="UNIX">
                </router-link>
              </div>
              <div class="tp-header-2-category tp-header-inner-category home-2 d-none d-md-block" v-if="categories.list?.length">
                <a class="tp-header-2-category-icon">
                  <p style="display: flex;"><span><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path class="color" d="M13.9998 4.564V1.386C13.9998 0.399 13.5518 0 12.4388 0H9.6108C8.4978 0 8.0498 0.399 8.0498 1.386V4.557C8.0498 5.551 8.4978 5.943 9.6108 5.943H12.4388C13.5518 5.95 13.9998 5.551 13.9998 4.564Z" fill="currentColor"/>
                                 <path opacity="0.4" d="M13.9998 12.439V9.611C13.9998 8.498 13.5518 8.05 12.4388 8.05H9.6108C8.4978 8.05 8.0498 8.498 8.0498 9.611V12.439C8.0498 13.552 8.4978 14 9.6108 14H12.4388C13.5518 14 13.9998 13.552 13.9998 12.439Z" fill="#1A73E8"/>
                                 <path opacity="0.4" d="M5.95 4.564V1.386C5.95 0.399 5.502 0 4.389 0H1.561C0.448 0 0 0.399 0 1.386V4.557C0 5.551 0.448 5.943 1.561 5.943H4.389C5.502 5.95 5.95 5.551 5.95 4.564Z" fill="#1A73E8"/>
                                 <path class="color" d="M5.95 12.439V9.611C5.95 8.498 5.502 8.05 4.389 8.05H1.561C0.448 8.05 0 8.498 0 9.611V12.439C0 13.552 0.448 14 1.561 14H4.389C5.502 14 5.95 13.552 5.95 12.439Z" fill="currentColor"/>
                                 </svg></span>
                    {{ lms_website.__('Categories') }}
                  </p>
                </a>
                <div class="tp-header-2-category-list">
                  <ul>
                    <li v-for="category in categories.list">
                      <router-link :to="{ name: 'courses.category', params: { id:category.name } }">{{ category?.category_name }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-8 d-none d-xl-block">
            <div class="main-menu text-lg-center d-none d-xl-block">
              <nav class="tp-main-menu-content">
                <ul class="tp-main-menu-content-ul" style="display: flex;">
                  <li class="tp-static">
                    <router-link :to="{ name: 'home' }">{{ lms_website.__('Home') }}</router-link>
                  </li>
                  <li class="p-static">
                    <router-link :to="{ name: 'courses.list' }">{{ lms_website.__('Courses') }}</router-link>
                  </li>
                  <li class="p-static">
                    <router-link :to="{ name: 'about_us' }">{{ lms_website.__('About UNIX') }}</router-link>
                  </li>
                  <li class="p-static">
                    <router-link :to="{ name: 'helpdesk' }">{{ lms_website.__('Contact Us') }}</router-link>
                  </li>
                  <!--                      <li class="has-dropdown"><a href="student-dashboard.html">Student Dashboard</a>-->
                  <!--                        <ul class="tp-submenu">-->
                  <!--                          <li><a href="student-dashboard.html">Dashboard</a></li>-->
                  <!--                          <li><a href="student-profile.html">Profile</a></li>-->
                  <!--                          <li><a href="student-enroll-course.html">Enrolled Courses</a></li>-->
                  <!--                          <li><a href="student-wishlist.html">Wishlist</a></li>-->
                  <!--                          <li><a href="student-reviews.html">Reviews</a></li>-->
                  <!--                          <li><a href="student-my-quiz.html">My Quiz Attempts</a></li>-->
                  <!--                          <li><a href="student-setting-profile.html">Settings</a></li>-->
                  <!--                        </ul>-->
                  <!--                      </li>-->
                </ul>
              </nav>
            </div>
          </div>
          <div class="col-xl-5 col-lg-8 col-6">
            <div class="tp-header-2-contact d-flex align-items-center justify-content-end">
              <div class="tp-header-inner-search">
                <button class="tp-search-open-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M13.4 13.4L17 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.4 8.19999C15.4 4.22354 12.1765 1 8.20001 1C4.22357 1 1.00002 4.22354 1.00002 8.19999C1.00002 12.1764 4.22357 15.4 8.20001 15.4C12.1765 15.4 15.4 12.1764 15.4 8.19999Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
              <div class="home-2 d-none d-xl-flex gap-2">
                <template v-if="!isLoggedIn()">
                  <router-link :to="{ name: 'student_applicant' }" class="btn btn-dark"><i class="far fa-user-plus mr-1"></i> {{ lms_website.__('Student Applicant') }}</router-link>
                  <router-link class="tp-btn-inner" :to="{ name: 'auth.login' , query: { redirect: $route.fullPath }}"><i class="far fa-sign-in mr-1"></i> {{ lms_website.__('Log In') }}</router-link>
                </template>
              </div>
              <button type="button" class="btn btn-light d-flex align-items-center" :class="{'ms-2':(current_language==='en')}" v-if="current_language" @click="switch_language(current_language)">
                <template v-if="current_language==='en'">
                  <div class="d-flex align-items-center" style="direction: rtl;">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:24px;border-radius:5px;" id="flag-icons-eg" viewBox="0 0 640 480">
                      <path fill="#000001" d="M0 320h640v160H0z"/>
                      <path fill="#fff" d="M0 160h640v160H0z"/>
                      <path fill="#ce1126" d="M0 0h640v160H0z"/>
                      <g fill="#fff" stroke="#c09300" transform="translate(-40)scale(.8)">
                        <path stroke-linejoin="round" stroke-width="1.3" d="m450.8 302.4 68.5 63.6-4.9-115.5c-.7-17.5-15.9-13.5-27-7.2-11.1 7.2-24 7.2-37.4 2.5-13.5 4.7-26.3 4.7-37.4-2.5-11-6.3-26.3-10.3-27 7.2L380.7 366z"/>
                        <path id="eg-a" fill="#c09300" stroke="none" d="m393.5 246.5-4.8 112.3-8 7.2 4.9-115.5a24 24 0 0 1 7.9-4m9.6 8-4 94-8 8.2 4.8-108.5c1.6 1.6 6.3 5.5 7.2 6.3m8.7 7.2-3.1 78.4-6.5 6.3 4-89.4c1.6 1.5 4.8 3.8 5.6 4.7m9.5 4-3.1 66.8-6.3 5.1 3.1-74.3c1.6.7 4.7 2.4 6.3 2.4m8.8 0-2.3 55.7-6.5 6.3 2.5-61.3c1.5 0 5.6 0 6.3-.7"/>
                        <use xlink:href="#eg-a" width="100%" height="100%" transform="matrix(-1 0 0 1 900 0)"/>
                        <path fill="#c09300" stroke-width="1.1" d="m453.2 315 9.6 43.8-3.2 3.2-3.3-2.5-5.4-39 2.3 39-3.2 4-3.1-4 2.3-39-5.5 39-3.3 2.5-3.2-3.2 9.6-43.7h6.4z"/>
                        <g id="eg-b" fill="none" stroke-linejoin="round" stroke-width="1.3">
                          <path fill="#fff" stroke-width="1.2" d="m428.5 295.8-19.1 67.7 26.3 4 11.1-50.9z"/>
                          <path d="m422.2 319 2.3 5.5 12.4-11.8"/>
                          <path d="m430.8 305 2.6 24.3 7.9-10.4m-3.2 4 4.3 15m1.7-5.5-8.7 13.2m2.7 13.2-2.8-13.2-2.4-13.4-5.9 7.9-2.5-9.1-8.2 8.4 4.1 15.2 5.8-9.4 3.1 9.6 6-9.2"/>
                          <path d="m415 362 5.3-7.5 3.4 11.5 4.8-8 3.1 9.6"/>
                        </g>
                        <use xlink:href="#eg-b" width="100%" height="100%" transform="matrix(-1 0 0 1 900 0)"/>
                        <g stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
                          <path stroke-width="2.4" d="M450 393.8c20 0 39-1.6 50.2-4.7 4.7-.9 4.7-3.3 4.7-6.5 4.8-1.6 2.4-7.2 5.7-7.2-3.4 1-4-5.5-8-4.7 0-5.6-5.7-6.3-10.4-4.7-9.5 3.1-26.3 3.9-42.2 3.9-16-.8-32.6-.8-42.2-4-4.7-1.5-10.3-.8-10.3 4.8-4-.8-4.7 5.6-8 4.7 3.3 0 .8 5.7 5.6 7.2 0 3.2 0 5.6 4.8 6.5 11 3.1 30.2 4.7 50.1 4.7"/>
                          <path d="M422.9 363.5c6.4.9 13.6 1.6 19.2.9 3.2 0 5.5 5.5-.9 6.3-5.5.7-14.3 0-19-.8a231 231 0 0 1-18.4-4c-5.6-2.4-1.6-7 1.6-6.4a105 105 0 0 0 17.5 4m54.2 0c-6.4.9-13.6 1.6-19 .9-3.4 0-5.7 5.5.7 6.3 5.6.7 14.3 0 19-.8 4-.8 12.8-2.3 18.4-4 5.6-2.4 1.6-7-1.6-6.4a105 105 0 0 1-17.5 4"/>
                          <path
                              d="M403 360.4c-4.8-.9-7 4.7-5.5 7.9.7-1.6 4-1.6 4.7-3.2.9-2.4-.7-2.4.9-4.7zm19.2 14.7c0-3.2 3.1-2.8 3.1-6 0-1.5-.8-4-2.4-4a3.4 3.4 0 0 0-3.2 3.2c-.7 3.1 2.5 3.6 2.5 6.8m22.7-9.1c4.7 0 4.2 6.3 2 9.5 0-2.3-4-3.2-4-4.8 0-2.4 3.6-2.4 2-4.7m52-5.6c4.9-.9 7.2 4.7 5.6 7.9-.7-1.6-4-1.6-4.7-3.2-.9-2.4.7-2.4-.9-4.7M478 375c0-3.2-3.2-2.8-3.2-6 0-1.5.8-4 2.4-4a3.4 3.4 0 0 1 3.2 3.2c.7 3.1-2.5 3.6-2.5 6.8zm-23-9c-4.7 0-4.2 6.3-2 9.5 0-2.3 4-3.2 4-4.8 0-2.4-3.6-2.4-2-4.7"/>
                          <path stroke-width=".9" d="M404.7 362c1.6 0 4 .7 4.7 1.6zm7.9 2.4c.8 0 4 .7 5.5 1.6zm28.6 3.2c-1.5 0-4.7 0-5.5.7l5.5-.8zm-8.7 0c-.9-.9-4-.9-5.6 0zm62.8-5.6a8 8 0 0 0-4.7 1.6zm-7.8 2.4c-1 0-4 .7-5.6 1.6zm-28.7 3.2c1.5 0 4.7 0 5.6.7l-5.6-.8zm8.7 0c.9-.9 4-.9 5.6 0z"/>
                          <g fill="#c09300" stroke="none">
                            <path d="M403.3 374.6q-.8-.3-.6-1 .3-1 1-.8c.4 0 .9.6.9.8l-.4.7-.2.1q-.1.3-.7.2m55 3.9q-.4-.2-.6-.7c0-.4.6-1 1-1l.8.4q.5.6-.1 1.2-.5.3-1.1 0zm.3 2.5q-.5-.2-.6-.8t.5-.9l.4-.2.4.2q.6.2.7.8 0 .5-.7.8-.4.3-.7 0z"/>
                            <path
                                d="M407.8 370q-.7.1-1.2.6c-.6.1-1.4.5-2 0-.6-.1-1.4 0-1.5.8.1.7 1 1 1.6.6.4-.5 1.5-.9 1.7 0-.5.8-.4 1.7-.8 2.4q-.1.7-.5 1.3-.8 0-1.4.3a2 2 0 0 0-1.6.8q-.7.9-.9 2c.1.6 1 .8 1.6.9l2 .6 3.2.9q2.4.6 4.8 1.1l.5.1c.7.2 1-.5 1-1l1-3.6c.2-.5.5-1.5-.4-1.3q-.7.6-1.6.8c-.9 0-.4 1 0 1.3q0 1-.5 1.8-.9.3-1.8-.2c-.5 0-1.7-.3-1.2-1l.5-1.8q.3-1 .5-2c-.4-.7-1 .3-1.5.4s-1.6.3-1 1c.6.4.2 1.1 0 1.7 0 .7-.8 1-1.4.7-.6 0-1.5-.5-1-1.1l.5-1.8.7-2q0-1 .6-1.8c0-.7.5-1.3.5-2q0-.4-.4-.4zm-3.7 7.3h.3q.3.3 0 .6l-.3.2q-.7 0-.6-.3 0-.1.3-.3zm-1 5q-.7-.5.3-1.3.4-.3.9.1.9.6 0 1.3-.2.3-.5.2t-.7-.2zm3 1a1 1 0 0 1-.6-1.1q.1-.6.9-.5.9-.1.9.7 0 .5-.3.7zm89.2 0q-.3-.1-.3-.5 0-.6.8-.9.9-.5 1.2.2.5.8-.1 1.2-.2.4-.8.3-.7 0-.8-.2zm-85 1.2q-.6-.1-.6-.8 0-.4.2-.6l.6-.2.6.1q.8.6.3 1.2t-1.2.3zm21.8 1-.2-.3q0-.9.2-1.7 0-.7.2-1.5l.4-2.8q0-.8.2-1.4 0-1.2.2-2.2c0-.3.3-1 .6-.6q.6.8 1.4 1.5c.4.3 0 .7-.3.8q-.6.3-.5 1l-.2 1.2q0 1-.2 2l-.1 1.8-.2 1.2q.1.7-.4 1.1-.6.3-1-.1zm29.7-9.8-1.3 1.2c-.6.5.5.7.6 1.1q.3.9.2 1.8.3.9.2 1.7c0 .7-.8.5-1.2.9q-.6.4-1 1l-.4 1.6c0 .5-.3 1 0 1.4l.1.2h.5l1.5-.1q1.9-.2 3.7-.3l2.2-.2c.6.1.9-.5.9-1-.4-.7-.1-1.4-.4-2q-.2-1.2-.2-2.2c0-.6-.7-.8-1-.4q-.7.4-1.2.9c-.3.6.6.6.8 1l.1 1.5c.1.6-.5.6-1 .7q-.9.4-1.5-.3-.2-.7-.2-1.5-.1-1.4-.3-2.7-.2-1.5-.3-3.2c0-.5-.1-1.2-.8-1.1m-.6 8.2h.3v.8l-.3.1-.4.1h-.2q-.3-.3.1-.8zm-30-9.2c-.3 0-.8.7-1.2.6-.9.1-.8 1-.1 1.3v.8c.1.8-.4 1.5-.3 2.3q-.1 1.2-.3 2.6-.4 1.4-.4 2.7c-.1.8-.7.5-1.2.3v-1q0-1.2-1.2-1.2-1-.1-.8-1.1.6-.4 1.5-.3c1 .2.9-1.1.4-1.6s-1.2-1-1.4-1.6q0-1.3-1.2-2.1c-1.1-.1-2 .8-2.3 1.8q-.8 0-1.4.4c-.7.2-1.7 1.4-.7 1.9.5.1 2.2.5 1.4 1.2q-.7 1-1.9.6c-.7 0-1.5-.4-1.5-1.2q0-1.2-.4-2.3c-.2-.8-1.1-.6-1.2.2q-1 1-.1 2 .3 1.2-.3 2.2c-.2 1-1.2 1-1.9 1.2-.3.2-1.6 0-1.1.7a4 4 0 0 0 2.4.3q1.2-.2 2-1.4c.5-.5 1.4-.2 2.2-.2.7 0 1.5.5 2.3.1.2-.5 1.2-1.5 1.5-.5q.2 1.4 1.5 1.2c.9 0 .5.6.5 1.2q.2 1.3 1.5 1.8h.8q1.2-.3 1.8-1.4.3-1.1.5-2.2.3-1.7.4-3.4.3-1.5.4-3.2l.3-2.3q0-.6-.5-.4m-6.7 4.1q.2 0 .2.5t.5.8v.3l-.8.2q-.7 0-1.2-.5l-.2-.2.3-.2.5-.5q.4-.4.7-.4m66-7.9-1.7.3c-1 0-1.5 1-.5 1.6.6 1.5 1.5-.4 2.5-.2 1.4.2 1.5 1.8 1.8 3q.1 1.6.7 3.3c1 1.1-.7 1.8-1.4 1-.6-.7-2-1.5-2.7-.6-.9.4-1 1.6-1.7 2-1.2.3-1.3-1.2-2-1.8-.6-.9-1.7-1-2.6-1.2-.4-.9-.2-2.4-1-3-.8.3-2.2 1.7-1 2.4 1 1-.5 1.4-1 2q-1.1 1.4-1 3c-1.3.7-1.5-.8-1.7-1.7 0-1.1-1-.8-1.7-.4q-1.3.8-2 2v2c.2.9 1.2.5 1.8.4 1-.4 1.4.7.6 1.3-.6.6-2.2.3-2 1.4h1.6c1-.3 2.2-1.1 2.3-2.3.2-1 1.7-.9 2.5-1.1 1-.3 2.3-.4 2.6 1 .7.7 2.2 1.5 3 .5a2 2 0 0 0 1.1-2.3c-.1-.8 1.3-.8 1.7-.3.5.8 2.1.6 2.9 0s1-1.6 2.2-1.6l5.4-1.5c1.4-.3-.2-1.2-.6-1.8-1-.5-2 1.7-3.2.6-1-.7-.9-2-1.2-3.1-.3-1.4-.2-3-1.2-4q-1-1-2.5-.9m-6.8 9.5q.2 0 .5.2.6.4.7 1 0 .2-.3.3l-.5.2q-.5-.1-.7-.5v-.4q-.3-.5 0-.6zm6.5.4q.5 0 .8.3.2.5-.4.8l-.5.2-.4-.3q-.3-.1-.3-.4.1-.5.8-.7zm-9 0q.3 0 .4.2.3.2.3.6v.6q.2.3-.6.2c-.8-.1-.7 0-.7-.6q0-.5.3-.7t.4-.2zm-5.4 1.5.4.4q0 .4-.2.6-.6.2-1 0v-.1q-.3-.2 0-.3v-.1l.2-.3a1 1 0 0 1 .6-.2m9.2 1.2.5.1v.6h-1.2l-.1-.2q0-.3.2-.4zm-17.1 4.8q-.3 0-.1-.2.3-.4.8-.6a3 3 0 0 0 1.4-1q.2-.5.4-1l-.1-1.4a2 2 0 0 0-.8-1q-.6 0-.8-.6.1-.4.4-.9l.6-1.2q.6-.3.8.2l.5 1q.4.4.6 1 .3.6.4 1l.2 1.3q0 .8-.2 1.6l-.6.8q-.4.5-1 .7-.4.3-.9.4H468zm-6.9.4q-.3-.2-.3-.6c0-.4 0-.3.3-.6q.4-.6 1.4 0t1 .1q.2-.4 1-.5l.5.2q.3.2.3.7c0 .5 0 .5-.3.8q-.3.2-.7.2a1 1 0 0 1-.8-.6q0-.4-.2-.1l-.2.1q-.4.1-.8.5l-.5.1q-.4 0-.7-.3m-19.8-8.9q-1.2.1-1.5 1.3c.2.7.8 1.5.4 2.2.3 1-.8 1.4-1.5.9q-.4-1.5-1.3-3c-.8-.2-1.1 1.1-1.7 1.6.3.7 1.1 1.4 1.2 2.3q.1 1.6-1.1 2.4c-.7.7-1.7.5-2.5.6-1 .6.7.8 1.2.8q1.6.3 3-.8c.7-.3.6-1.7 1.5-1.8l4.8.3c.8.2 2.1-.1 2.7.5 0 1 1 1.8 1.9 2.2.5.2 1-.5 1.5-.6 1-.3.7-1.5 1.3-2h5c.2 0 .3-.5.6-.7l-.2-1.9c-.3-.8 0-1.8-.5-2.5-.9-.2-1.6.5-2.4.6q-1.6.7-1.8 2.3c-.5.9-1.4-.2-1-1l-.1-1c-.5-.5-1.4-.3-2.1-.4l-3-.2q-1.5.1-2.7-.1c-1 0-1-1-1-1.8zm2 3.7 1 .1h1.3q1.5.3 3 .2.3 0 .6.4v2q0 .5-.2.8l-.2.2-.7-.5v-1.4l-.7-.3-2.6-.1-2-.1q-.5 0-.9-.4-.2-.4.4-.7zm11.3.3q.2 0 .2.3l.2.5q0 .2-.2.2-.8.3-1.2 0 0-.3.2-.6z"/>
                          </g>
                        </g>
                        <path stroke-width="1.1" d="M450 327.2c32.6-25 29.8-61.8 29.8-61.8l-2.5.2c-6.9 0-23.2-4-27-8.9-4 4.5-20.8 9-27.6 9l-2.5-.3s-2.9 36.7 29.8 61.8z"/>
                        <path stroke-width=".9" d="M477.2 268h-.8c-6.2 0-20.6-3.1-26.2-7.9-5.8 4.4-20.5 8-26.6 8l-.8-.1a73 73 0 0 0 2.6 18.7 71 71 0 0 0 24.6 37.1 71 71 0 0 0 24.6-37.2 73 73 0 0 0 2.6-18.6z"/>
                        <path fill="#c09300" stroke="none" d="M439.4 265a62 62 0 0 1-16.6 3l.1 4.1a73 73 0 0 0 2.5 14.5 71 71 0 0 0 14 26.8zm20.6 0v49.2a71 71 0 0 0 14.6-27.6 73 73 0 0 0 2.5-14.5l.1-4h-.8c-3.8 0-10.4-1.2-16.4-3.2z"/>
                        <g stroke-width="1.3">
                          <path stroke-width="1.2" d="M462.3 253c.7.1-.9-3.5-.9-3.5 1.8 1.8 8.4 2.3 8.4 2.3-4-1.8-8-15.1-7.5-25.8.4-10.6-1.5-14.8-3-16.4-2-2-8.5-3.8-12.7-4-2.5-.1-2 1.8-2 1.8-4.5-1.1-9-1.6-11-.2-1.8 1.2-2.2 7.5-.8 6.4 3.3-2.7 6.2-.2 8.2 2.7 1.8 2.5 1.7 9.7-.9 18.2a60 60 0 0 1-10 17.7c4 0 9.6-3.5 9.6-3.5l-1.3 5.5c4.2-2 7.5-5.1 7.5-5.1l4 4.2c1.3-1.8 4-4.2 4-4.2s3.3 3.5 8.4 4z"/>
                          <path fill="none" d="M446.1 227.6s-2.2 16.4-6.4 21m10-21.5s-1 16.7-3.8 22m6.9-21.3s0 18.2 1 21.3m3-20.4s.8 15.3 4.6 20.8"/>
                          <path fill="#c09300" stroke-width=".3" d="M442 219.6a8 8 0 0 0-1-3.3c-2-3-4.9-5.4-8.2-2.7 0 0 1.1-3.5 3.6-3.6 1.8-.1 6.1 1.4 9.9 7.8 0 0-2.8-.6-3.5 0-1.2 1-.7 1.8-.7 1.8z"/>
                          <path fill="#c09300" stroke-width=".3" d="M432.4 209.3q.4-1.6 1.3-2.1c2-1.4 6.4-1 10.9.2 0 0-.4-1.9 2-1.8 4.2.2 10.6 2 12.6 4a8 8 0 0 1 1.5 2.4c-1-1.4-3.8-1.3-4.5-1.2-1 .1-1.7 0-3.1.4q-1.2.3-2.3.8c-.4.4-.8 1.6-1.4 1.6-1 0-1-.2-1.3-.5q-.4-1-.9-1-1.6.2-5-2.5c-2.3-1.8-3.2-2.2-6-2-3 .2-3.8 1.9-3.8 1.9z"/>
                          <circle cx="448.8" cy="210.7" r="1.2" stroke="none"/>
                        </g>
                      </g>
                    </svg>
                    <span style="margin-right:10px;font-size:14px;">عربي</span>
                  </div>
                </template>
                <template v-if="current_language==='ar'">
                  <div class="d-flex align-items-center" style="direction: ltr;">
                    <svg xmlns="http://www.w3.org/2000/svg" style="width:24px;border-radius:5px;" id="flag-icons-us" viewBox="0 0 640 480">
                      <path fill="#bd3d44" d="M0 0h640v480H0"/>
                      <path stroke="#fff" stroke-width="37" d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"/>
                      <path fill="#192f5d" d="M0 0h364.8v258.5H0"/>
                      <marker id="us-a" markerHeight="30" markerWidth="30">
                        <path fill="#fff" d="m14 0 9 27L0 10h28L5 27z"/>
                      </marker>
                      <path fill="none" marker-mid="url(#us-a)" d="m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"/>
                    </svg>
                    <span style="margin-left:10px;font-size:14px;">English</span>
                  </div>
                </template>
              </button>
              <template v-if="isLoggedIn()">
                <div class="tp-header-inner-login tp-header-user-hover">
                  <button><img :src="(auth?.user?.user_image)?auth?.user?.user_image:'/assets/lms_website/images/user.png'" :alt="auth?.user?.fullname"></button>
                  <div class="tp-header-user-box">
                    <div class="tp-header-user-content">
                      <div class="tp-header-user-profile d-flex align-items-center">
                        <div class="tp-header-user-profile-thumb">
                          <img :src="(auth?.user?.user_image)?auth?.user?.user_image:'/assets/lms_website/images/user.png'" :alt="auth?.user?.fullname"/>
                        </div>
                        <div class="tp-header-user-profile-content">
                          <h4>{{ auth?.user?.full_name || auth?.user?.first_name }}</h4>
                          <span class="text-truncate d-block" style="width:170px;">{{ auth?.user?.user_category || auth?.user?.email }}</span>
                        </div>
                      </div>
                      <div class="tp-header-user-list">
                        <ul>
                          <li>
                            <router-link :to="{ name: 'profile.view' }">
                            <span>
                                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        opacity="0.4"
                                        d="M7.98015 8.78062C10.4049 8.78062 12.3705 6.81501 12.3705 4.39031C12.3705 1.96561 10.4049 0 7.98015 0C5.55545 0 3.58984 1.96561 3.58984 4.39031C3.58984 6.81501 5.55545 8.78062 7.98015 8.78062Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M7.98158 10.9755C3.58249 10.9755 0 13.9258 0 17.5609C0 17.8068 0.193174 18 0.439031 18H15.5241C15.77 18 15.9632 17.8068 15.9632 17.5609C15.9632 13.9258 12.3807 10.9755 7.98158 10.9755Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </span>
                              {{ lms_website.__('My Profile') }}
                            </router-link>
                          </li>
                          <li v-if="is_desk_user()">
                            <a href="/app">
                            <span>
                               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path opacity="0.4" d="M16.0041 5.216V1.584C16.0041 0.456 15.4921 0 14.2201 0H10.9881C9.7161 0 9.2041 0.456 9.2041 1.584V5.208C9.2041 6.344 9.7161 6.792 10.9881 6.792H14.2201C15.4921 6.8 16.0041 6.344 16.0041 5.216Z" fill="currentColor"></path>
                                  <path d="M16.0041 14.216V10.984C16.0041 9.71195 15.4921 9.19995 14.2201 9.19995H10.9881C9.7161 9.19995 9.2041 9.71195 9.2041 10.984V14.216C9.2041 15.488 9.7161 16 10.9881 16H14.2201C15.4921 16 16.0041 15.488 16.0041 14.216Z" fill="currentColor"></path>
                                  <path d="M6.8 5.216V1.584C6.8 0.456 6.288 0 5.016 0H1.784C0.512 0 0 0.456 0 1.584V5.208C0 6.344 0.512 6.792 1.784 6.792H5.016C6.288 6.8 6.8 6.344 6.8 5.216Z" fill="currentColor"></path>
                                  <path opacity="0.4" d="M6.8 14.216V10.984C6.8 9.71195 6.288 9.19995 5.016 9.19995H1.784C0.512 9.19995 0 9.71195 0 10.984V14.216C0 15.488 0.512 16 1.784 16H5.016C6.288 16 6.8 15.488 6.8 14.216Z" fill="currentColor"></path>
                               </svg>
                            </span>
                              {{ lms_website.__('Switch to Desk') }}
                            </a>
                          </li>
                          <li>
                            <router-link :to="{ name: 'profile.enrolled_courses' }">
                              <span>
                                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path opacity="0.4"
                                        d="M13.4349 9.71387V13.9033C13.4349 14.9826 12.593 16.1383 11.581 16.4782L8.86831 17.379C8.3921 17.5404 7.61825 17.5404 7.15054 17.379L4.43782 16.4782C3.41736 16.1383 2.58398 14.9826 2.58398 13.9033L2.59249 9.71387L6.35118 12.1613C7.26959 12.7646 8.78328 12.7646 9.70169 12.1613L13.4349 9.71387Z"
                                        fill="currentColor"></path>
                                  <path
                                      d="M14.7945 4.29218L9.70074 0.952512C8.78233 0.349163 7.26865 0.349163 6.35023 0.952512L1.23093 4.29218C-0.41031 5.35441 -0.41031 7.75931 1.23093 8.83004L2.59154 9.71382L6.35023 12.1612C7.26865 12.7646 8.78233 12.7646 9.70074 12.1612L13.4339 9.71382L14.5989 8.94901V11.5494C14.5989 11.8978 14.8881 12.1867 15.2367 12.1867C15.5854 12.1867 15.8745 11.8978 15.8745 11.5494V7.36841C16.2147 6.27218 15.866 4.9975 14.7945 4.29218Z"
                                      fill="currentColor"></path>
                                </svg>
                              </span>
                              {{ lms_website.__('Enrolled Courses') }}
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ name: 'profile.enrolled_courses', query: { tab: 'resources' } }">
                              <span>
                                 <i class="fad fa-folder-open"></i>
                              </span>
                              {{ lms_website.__('Resources') }}
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ name: 'profile.orders_history' }">
                              <span>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.4"
                                      d="M14.2903 2.86564H13.9703L11.2667 0.16198C11.0507 -0.0539932 10.6987 -0.0539932 10.4748 0.16198C10.2588 0.377953 10.2588 0.729909 10.4748 0.953881L12.3865 2.86564H4.61149L6.52325 0.953881C6.73922 0.737908 6.73922 0.385952 6.52325 0.16198C6.30727 -0.0539932 5.95532 -0.0539932 5.73135 0.16198L3.03568 2.86564H2.71572C1.99581 2.86564 0.5 2.86564 0.5 4.91339C0.5 5.68929 0.65998 6.20122 0.995938 6.53718C1.18791 6.73716 1.41989 6.84114 1.66785 6.89714C1.89982 6.95313 2.14779 6.96113 2.38776 6.96113H14.6102C14.8582 6.96113 15.0902 6.94513 15.3141 6.89714C15.9861 6.73716 16.498 6.25722 16.498 4.91339C16.498 2.86564 15.0022 2.86564 14.2903 2.86564Z"
                                      fill="currentColor"/>
                                <path
                                    d="M14.6193 6.96103H2.38886C2.15688 6.96103 1.90092 6.95303 1.66895 6.88904L2.67682 13.0403C2.90079 14.4161 3.50072 15.9999 6.16438 15.9999H10.6518C13.3475 15.9999 13.8274 14.6481 14.1154 13.1363L15.3232 6.88904C15.0993 6.94503 14.8593 6.96103 14.6193 6.96103ZM8.50009 13.2002C6.62833 13.2002 5.10052 11.6724 5.10052 9.80067C5.10052 9.47272 5.37248 9.20075 5.70044 9.20075C6.0284 9.20075 6.30037 9.47272 6.30037 9.80067C6.30037 11.0165 7.28424 12.0004 8.50009 12.0004C9.71594 12.0004 10.6998 11.0165 10.6998 9.80067C10.6998 9.47272 10.9718 9.20075 11.2997 9.20075C11.6277 9.20075 11.8997 9.47272 11.8997 9.80067C11.8997 11.6724 10.3719 13.2002 8.50009 13.2002Z"
                                    fill="currentColor"/>
                             </svg>
                              </span>
                              {{ lms_website.__('Orders History') }}
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{name:'profile.discuss'}">
                              <span>
                                 <i class="fad fa-comments-alt"></i>
                              </span>
                              {{ lms_website.__('Discuss') }}
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ name: 'profile.settings' }">
                              <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.60509 10.2644C6.32151 10.2644 5.2832 9.26439 5.2832 8.00839C5.2832 6.75239 6.32151 5.74438 7.60509 5.74438C8.88867 5.74438 9.90245 6.75239 9.90245 8.00839C9.90245 9.26439 8.88867 10.2644 7.60509 10.2644Z" fill="currentColor"/>
                                <path opacity="0.4"
                                      d="M14.9841 9.896C14.8288 9.656 14.608 9.416 14.3219 9.264C14.093 9.152 13.9458 8.968 13.815 8.752C13.398 8.064 13.6433 7.16 14.3382 6.752C15.1558 6.296 15.4174 5.28 14.9432 4.488L14.3955 3.544C13.9294 2.752 12.9075 2.472 12.0981 2.936C11.3786 3.32 10.4548 3.064 10.0378 2.384C9.90702 2.16 9.83344 1.92 9.84979 1.68C9.87432 1.368 9.77621 1.072 9.62905 0.832C9.32655 0.336 8.77878 0 8.17378 0H7.02101C6.42419 0.016 5.87642 0.336 5.57392 0.832C5.41858 1.072 5.32865 1.368 5.345 1.68C5.36135 1.92 5.28777 2.16 5.15696 2.384C4.74 3.064 3.81615 3.32 3.10487 2.936C2.28731 2.472 1.27352 2.752 0.799336 3.544L0.251567 4.488C-0.214445 5.28 0.0471757 6.296 0.856566 6.752C1.5515 7.16 1.79677 8.064 1.38798 8.752C1.249 8.968 1.10184 9.152 0.872917 9.264C0.594945 9.416 0.349675 9.656 0.218865 9.896C-0.0836348 10.392 -0.0672835 11.016 0.235216 11.536L0.799336 12.496C1.10184 13.008 1.66596 13.328 2.2546 13.328C2.53258 13.328 2.8596 13.248 3.12122 13.088C3.32561 12.952 3.57088 12.904 3.84068 12.904C4.65007 12.904 5.32865 13.568 5.345 14.36C5.345 15.28 6.09716 16 7.04554 16H8.15743C9.09763 16 9.84979 15.28 9.84979 14.36C9.87432 13.568 10.5529 12.904 11.3623 12.904C11.6239 12.904 11.8692 12.952 12.0817 13.088C12.3434 13.248 12.6622 13.328 12.9484 13.328C13.5288 13.328 14.093 13.008 14.3955 12.496L14.9678 11.536C15.2621 11 15.2866 10.392 14.9841 9.896Z"
                                      fill="currentColor"/>
                                </svg>
                              </span>
                              {{ lms_website.__('Settings') }}
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ name: 'auth.logout' }">
                              <span>
                                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        opacity="0.4"
                                        d="M9.94863 0C10.3714 0 10.7222 0.341829 10.7222 0.773613V17.2264C10.7222 17.6492 10.3804 18 9.94863 18C4.65028 18 0.953125 14.3028 0.953125 9.0045C0.953125 3.70615 4.65927 0 9.94863 0Z"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M16.5143 8.58188L13.9596 6.01816C13.6987 5.75729 13.2669 5.75729 13.006 6.01816C12.7452 6.27903 12.7452 6.71082 13.006 6.97169L14.4093 8.37498H5.80064C5.43182 8.37498 5.12598 8.68083 5.12598 9.04965C5.12598 9.41846 5.43182 9.72431 5.80064 9.72431H14.4093L13.006 11.1276C12.7452 11.3885 12.7452 11.8203 13.006 12.0811C13.141 12.2161 13.3119 12.279 13.4828 12.279C13.6537 12.279 13.8246 12.2161 13.9596 12.0811L16.5143 9.51741C16.7752 9.26554 16.7752 8.84275 16.5143 8.58188Z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </span>
                              {{ lms_website.__('Logout') }}
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="offcanvas-btn d-xl-none ml-30">
                <button class="offcanvas-open-btn"><i class="fa-solid fa-bars"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- header-area-end -->
</template>

<script>

import {isLoggedIn, authData} from '../utils/auth';
import {getCookie, setCookie} from "../utils/utils";

export default {
  name: "Header",
  setup() {
    return {
      isLoggedIn,
      setCookie,
      getCookie,
      lms_website,
      frappe
    }
  },
  data() {
    return {
      current_language: null,
      authData: authData() || {
        user: {}
      },
      batches: {
        list: []
      },
      categories: {
        list: []
      }
    }
  },
  methods: {
    get_categories() {
      frappe.call({
        type: "GET",
        method: "lms_website.api.utils.get_home_categories",
        args: {},
        callback: ({message}) => {
          this.categories.list = message;
        },
      });
    },
    get_batches() {
      frappe.call({
        type: "GET",
        method: "lms_website.api.utils.get_header_batches",
        args: {},
        callback: ({message}) => {
          this.batches.list = message;
        }
      });
    },
    encode_param(param) {
      return encodeURIComponent(param);
    },
    is_desk_user() {
      return (lms_website.user_session === 'Administrator' || (!frappe.user_roles.includes('Student') && !frappe.user_roles.includes('Student Role')))
    },
    switch_language(language) {
      let current_language = (language === 'en') ? 'ar' : 'en';
      if (isLoggedIn()) {
        frappe.xcall('lms_website.api.utils.change_language', {language: current_language}).then(() => {
          setCookie("preferred_language", current_language, 30);
          window.location.reload();
        });
      } else {
        setCookie("preferred_language", current_language, 30);
        window.location.reload();
      }
    },
    async get_current_language() {
      if (isLoggedIn()) {
        await frappe.xcall('lms_website.api.user.get_user_language').then((language) => {
          this.current_language = language
        });
      } else {
        this.current_language = getCookie('preferred_language', 'en');
      }
    }
  },
  computed: {
    auth() {
      if (this.authData && this.authData.is_logged_in && this.authData.user) {
        return this.authData;
      }
      return null;
    },
  },
  watch: {},
  mounted() {
    this.get_categories();
    this.get_current_language();
    setTimeout(() => {

      // 02. Mobile menu js
      if ($('.tp-main-menu-content').length && $('.tp-main-menu-mobile').length) {
        let navContent = document.querySelector(".tp-main-menu-content").outerHTML;
        let mobileNavContainer = document.querySelector(".tp-main-menu-mobile");
        mobileNavContainer.innerHTML = navContent;

        let arrow = $(".tp-main-menu-mobile .has-dropdown > a");

        arrow.each(function () {
          let self = $(this);
          let arrowBtn = document.createElement("BUTTON");
          arrowBtn.classList.add("dropdown-toggle-btn");

          // Append the arrow button after the link
          self[0].appendChild(arrowBtn);

          function toggleDropdown(e) {
            e.preventDefault();
            let self = $(this);
            let parent = self.parent();
            let submenu = parent.children(".tp-submenu, .tp-megamenu-main");

            self.toggleClass("dropdown-opened");
            parent.toggleClass("expanded");
            parent.parent().addClass("dropdown-opened").siblings().removeClass("dropdown-opened").find(".tp-submenu, .tp-megamenu-main").slideUp();

            submenu.slideToggle();
          }

          // Add event listeners to both the link and the button
          self.on("click", toggleDropdown);
          $(arrowBtn).on("click", toggleDropdown);
        });
      }

      if ($('.tp-header-user-hover').length > 0) {
        window.addEventListener('click', function (e) {
          let clickedElement = e.target;

          $('.tp-header-user-hover').each(function () {
            if (this.contains(clickedElement)) {
              $(this).toggleClass('active');
            } else {
              $(this).removeClass('active');
            }
          });
        });
      }

      // 07. Search Js
      $(".tp-search-open-btn").on("click", function () {
        $(".tp-search-area").addClass("opened");
        $(".body-overlay").addClass("opened");
      });

      $(".tp-search-close-btn").on("click", function () {
        $(".tp-search-area").removeClass("opened");
        $(".body-overlay").removeClass("opened");
      });

      // . language
      if ($("#header-bottom__lang-toggle").length > 0) {
        window.addEventListener('click', function (e) {
          if (document.getElementById('header-bottom__lang-toggle').contains(e.target)) {
            $(".header-bottom__lang-submenu, .header-bottom__lang-submenu-2").toggleClass("open");
          } else {
            $(".header-bottom__lang-submenu, .header-bottom__lang-submenu-2").removeClass("open");
          }
        });
      }
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), only screen and (max-width: 767px) {
    .tp-main-menu-content {
        margin-bottom: 40px;
    }
    .tp-main-menu-content-ul{
        display: flex;
        flex-direction: column;
    }
}
</style>
